import axios from "axios";
import Cookies from "js-cookie";
import * as types from "../mutation-types";
import Vue from 'vue';
import store from "store2";
import languages from "@/assets/languages.json";
import { Store } from "vuex";

const Storage = window.localStorage;
// state
export const state = {
    user: {
        'email': Storage.getItem("email"),
        'custom:tenant_id': Storage.getItem("custom:tenant_id"),
    },
    checkUser: false,
    token: Storage.getItem("token"),
    access_token: Storage.getItem('access_token'),
    appId: Storage.getItem("APP_ID"),
    authTried: 0
};

// getters
export const getters = {
    user: state => state.user,
    appId: state => state.appId,
    token: state => state.token,
    access_token: state => state.access_token,
    check: state => (state.user && Object.keys(state.user).length > 2),
    checUser: state => state.checUser,
    check_commercial: state => true,
    authTried: state => state.authTried
};

// mutations
export const mutations = {
    [types.SAVE_TOKEN](state, { token, access_token, expires_in }) {
        state.token = (token) ? token : access_token;
        Storage.setItem("token", state.token, { expires: expires_in });
    },
    [types.SAVE_ACCESS_TOKEN](state, { access_token, expires_in }) {
        state.access_token = access_token;
        Storage.setItem("access_token", access_token, { expires: expires_in });
    },

    [types.SAVE_ACCOUNT_EMAIL](state, { email, expires_in }) {

        if(email)
            state.user = {
                ...state.user,
                email
            };
            
        Storage.setItem("email", state.user.email, { expires: expires_in });
    },
    [types.SAVE_ACCOUNT_TENANT_ID](state, { accountId, expires_in }) {

        if(accountId){
            state.user = {
                ...state.user,
                "custom:tenant_id": accountId
            };
        }
        
        Storage.setItem("custom:tenant_id", state.user["custom:tenant_id"], { expires: expires_in });
    },

    [types.FETCH_USER_SUCCESS](state, { user }) {
        state.user = {
            ...state.user,
            ...user
        };
        state.checUser = true;
    },

    [types.SAVE_AUTH_TRIED](state, { count }) {
        state.authTried = count;
    },

    [types.FETCH_USER_FAILURE](state) {
        state.token = null;
        Storage.removeItem("token");
    },

    [types.APP_ID](state, { appId }) {
        Vue.set(state, 'appId', appId);
        Storage.setItem("APP_ID", appId);
    },

    [types.LOGOUT](state) {
        state.user = null;
        state.token = null;
        state.access_token = null;
        state.appId = null;
        Storage.removeItem("token");
        Storage.removeItem("access_token");
        Storage.removeItem("ACCOUNT_EMAIL");
        Storage.removeItem("APP_ID");
        Storage.removeItem("ACCOUNT_TENANT_ID");

        Storage.clear();

    }
};

// actions
export const actions = {
    saveToken({ commit }, payload) {
        //Hacer calculo de segundos a dias
        payload.expires_in = payload.expires_in / 86400;
        //payload.expires_in= 1/(1440 * 5);
        commit(types.SAVE_TOKEN, payload);
        commit(types.SAVE_ACCESS_TOKEN, payload);
        commit(types.SAVE_ACCOUNT_EMAIL, payload);
        commit(types.SAVE_ACCOUNT_TENANT_ID, payload);
    },

    async fetchUser({ commit, dispatch }) {
        try {
            let data = await axios.get('/account.api/user');

            var info = data['data']['_items'];
            /* var cleanData = {};
            function filterColumns(element, index, array) {
                cleanData[element['name']] = element['value'];
            }

            info.forEach(filterColumns);
            data = cleanData; */
            commit(types.FETCH_USER_SUCCESS, { user: info })

            dispatch('auth/setLanguageUser', { user: info }, { root: true });
        } catch (e) {
            commit(types.FETCH_USER_FAILURE)
        }
    },

    setLanguageUser({ commit, dispatch }, payload) {
        let data = payload.user;
        if (data && data["custom:language_id"]) {
            let userLanguage = languages.find((lang) => {
                return lang.id && (parseInt(lang.id) == data["custom:language_id"]);
            });
            if (userLanguage) {
                dispatch("lang/setLocale", { locale: userLanguage.code }, { root: true });
            }
        }
    },

    setAuthTried({ commit }, payload) {
        commit(types.SAVE_AUTH_TRIED, payload);
    },

    addAuthTried({ commit, state }, payload) {
        commit(types.SAVE_AUTH_TRIED, { count: state.authTried + 1 });
    },

    async logout({ commit }) {
        commit(types.LOGOUT);
    },

    async updateAppId({ commit, state }, payload) {
        let axiosConfig = {
            url: "/account.api/accessKeys",
            method: "GET"
        }
        try {
            const { data } = await axios(axiosConfig);
            commit(types.APP_ID, { appId: data.app_id });
        } catch (error) {
            throw error;
        }
    },
};